"use client";
import { NumSlider } from "src/components/ui/NumSlider";
import React, { Component } from "react";
import Currency from "../../CurrentCurrency";
import Case from "../Case.jsx";
import Example from "../Example.jsx";
import Text from "../../../src/components/ui/Text";

class MultipleExample extends Component {
  mainBody = ({ rate, period, multiple, onRateChange, onPeriodChange }) => {
    return (
      <Text>
        With{" "}
        <NumSlider
          num={rate}
          min={1}
          max={16}
          percent
          onChange={onRateChange}
        />{" "}
        interest rate, in{" "}
        <NumSlider
          num={period}
          step={1}
          min={1}
          max={40}
          onChange={onPeriodChange}
        />{" "}
        years your initial investment would grow approximately {multiple} times.
        In other words:
        <ul className="list-none">
          <li>
            <Currency amount={1000} /> would grow to{" "}
            <Currency amount={1000 * multiple} />.
          </li>
          <li>
            <Currency amount={1000000} /> would grow to{" "}
            <Currency amount={1000000 * multiple} />.
          </li>
        </ul>
      </Text>
    );
  };
  render() {
    const { rate, period } = this.props;

    return (
      <Example>
        <Case rate={rate} period={period}>
          {({ multiple, ...props }) =>
            this.mainBody({
              ...props,
              multiple: multiple && multiple.toFixed(2),
            })
          }
        </Case>
      </Example>
    );
  }
}

export default MultipleExample;
